import React, { useEffect, useRef, useState } from "react";
import * as d3 from "d3";

const IncidentPieChart = ({ data }) => {
  const svgRef = useRef();

  const [dimensions, setDimensions] = useState({ width: 300, height: 300 });

  useEffect(() => {
    const handleResize = () => {
      const width = svgRef.current.parentElement.offsetWidth;
      const height = svgRef.current.parentElement.offsetHeight;
      setDimensions({ width, height });
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  useEffect(() => {
    const { width, height } = dimensions;
    const radius = Math.min(width, height) / 2;

    // Prepare data: count incidents by type
    const incidentCounts = d3.rollup(
      data,
      v => v.length,
      d => d.type
    );
    const pieData = Array.from(incidentCounts, ([key, value]) => ({
      type: key,
      count: value,
    }));

    const colorScale = d3.scaleOrdinal()
      .domain(pieData.map(d => d.type))
      .range(d3.schemeCategory10);

    const arcGenerator = d3.arc()
      .innerRadius(0)
      .outerRadius(radius);

    const pieGenerator = d3.pie()
      .value(d => d.count);

    const pieChartData = pieGenerator(pieData);

    const svg = d3.select(svgRef.current)
      .attr("width", width)
      .attr("height", height)
      .append("g")
      .attr("transform", `translate(${width / 2}, ${height / 2})`);

    // Draw pie slices
    svg.selectAll("path")
      .data(pieChartData)
      .enter()
      .append("path")
      .attr("d", arcGenerator)
      .attr("fill", d => colorScale(d.data.type))
      .attr("stroke", "#fff")
      .attr("stroke-width", 2)
      .on("mouseover", (event, d) => {
        d3.select(event.currentTarget)
          .transition()
          .duration(200)
          .attr("transform", "scale(1.1)");
      })
      .on("mouseout", (event) => {
        d3.select(event.currentTarget)
          .transition()
          .duration(200)
          .attr("transform", "scale(1)");
      });

    // Add labels
    svg.selectAll("text")
      .data(pieChartData)
      .enter()
      .append("text")
      .attr("transform", d => `translate(${arcGenerator.centroid(d)})`)
      .attr("text-anchor", "middle")
      .attr("font-size", "12px")
      .text(d => `${d.data.type}: ${d.data.count}`);

    // Cleanup function
    return () => {
      d3.select(svgRef.current).selectAll("*").remove();
    };
  }, [data]);

  return <svg ref={svgRef}></svg>;
};

export default IncidentPieChart;
